export default __webpack_public_path__ + "static/media/horn.9aef2bb9.mp3";